module.exports = __webpack_public_path__ + "img/no-person-img.f2ae27a.png";